import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={54}
    height={39}
    viewBox='0 0 54 39'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.313 38.459q-2.814 0-4.792-1.98-1.98-1.978-1.98-4.791H1.5l.594-2.708h6.14a6.45 6.45 0 0 1 2.37-2.936q1.635-1.127 3.709-1.127t3.708 1.127a6.45 6.45 0 0 1 2.37 2.936h12.505l5.948-25.73h-24.24l.579-2.708h27.046l-2.193 9.48h5.63l7.345 9.791-2.345 11.875h-3.124q0 2.812-1.98 4.792t-4.791 1.979-4.792-1.98T34 31.689H21.083q0 2.812-1.979 4.792t-4.791 1.979m22.713-15.573h12.6l.479-2.412-5.792-7.744H39.39zM38.844 3.25l-5.948 25.73.656-2.714zM5.51 21.584v-7.448H.458l7.656-12.24v7.448h5.053zm8.803 14.166q1.671 0 2.867-1.195t1.195-2.867q0-1.672-1.195-2.868-1.196-1.194-2.867-1.195-1.672 0-2.868 1.195t-1.195 2.868q0 1.671 1.195 2.867t2.867 1.195m26.458 0q1.671 0 2.867-1.195t1.195-2.867-1.195-2.868q-1.196-1.194-2.867-1.195-1.672 0-2.868 1.195-1.194 1.196-1.195 2.868 0 1.671 1.195 2.867t2.868 1.195'
      fill='#E4E4F9'
    />
  </svg>
);
export default SVGComponent;
